import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { KendoDialogService } from '../services/kendo-dialog.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class DirtyGuardService implements CanDeactivate<ComponentCanDeactivate> {
  constructor(private kendoDialog: KendoDialogService) {}

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    const canDeactivateResult = component.canDeactivate();

    // If result is an Observable, return it to let async logic run
    if (canDeactivateResult instanceof Observable) {
      return canDeactivateResult;
    }

    // If component says it's safe to leave, allow navigation
    if (canDeactivateResult === true) {
      return true;
    }

    // Component has unsaved changes - show confirmation dialog
    return this.kendoDialog.confirm({
      title: 'Unsaved Changes',
      message: 'You have unsaved changes. Do you want to discard these changes and leave the page?',
      confirmText: 'Discard Changes',
      cancelText: 'Stay on Page'
    });
  }
}
